import { Component } from '@angular/core';
import { RouterLink } from "@angular/router";
import { GenericTable, GenericTableAction, GenericTableColumn } from '../../../../models/GenericCRUD/GenericTable';
import { GenericForm, GenericFormField } from '../../../../models/GenericCRUD/GenericForm';
import { Paginator } from '../../../../models/Paginator';
import { GenericCRUD } from '../../../../models/GenericCRUD/GenericCRUD';
import { GenericCrudComponent } from "../../../../shared/components/generic-crud/generic-crud.component"
import { Filter } from '../../../../models/GenericCRUD/Filter';
import { BreadcrumbService } from '../../../../core/services/breadcrumb/breadcrumb.service';

@Component({
  selector: 'app-vehicle-configuration',
  standalone: true,
  imports: [
    RouterLink,
    GenericCrudComponent
  ],
  templateUrl: './vehicle-configuration.component.html',
  styleUrl: './vehicle-configuration.component.css'
})
export class VehicleConfigurationComponent {
  tableColums: GenericTableColumn[] = [
    { name: 'ID', active: false, type: 'text', key: 'id', sort: true },
    { name: 'Matrícula', active: true, type: 'text', key: 'license_plate', sort: true },
    { name: 'Estado', active: true, type: 'text', key: 'status.name', sort: true },
    { name: 'Modelo', active: true, type: 'text', key: 'model', sort: true },
    { name: 'Fecha Matriculación', active: false, type: 'date', key: 'registration_date', sort: true, format: 'dd/MM/yyyy' },
    { name: 'Próxima ITV', active: true, type: 'date', key: 'next_itv_date', sort: true, format: 'dd/MM/yyyy' },
    { name: 'Próximo Mantenimiento (km)', active: true, type: 'text', key: 'next_maintenance_km', sort: true },
  ];

  formFields: GenericFormField[] = [
    { name: 'license_plate', type: 'text', label: 'Matrícula', validations: 'required' },
    { name: 'vehicle_status_id', type: 'select', label: 'Estado', validations: 'required', url: '/config/vehicles/statuses', singleSelection: true },
    { name: 'model', type: 'text', label: 'Modelo' },
    { name: 'registration_date', type: 'date', label: 'Fecha Matriculación' },
    { name: 'itv_date', type: 'date', label: 'Fecha ITV' },
    { name: 'next_itv_date', type: 'date', label: 'Próxima ITV' },
    { name: 'maintenance_km', type: 'number', label: 'Km Mantenimiento Actual' },
    { name: 'next_maintenance_km', type: 'number', label: 'Próximo Mantenimiento (km)' },
  ];

  formFieldsEdit: GenericFormField[] = [
    { name: 'license_plate', type: 'text', label: 'Matrícula', validations: 'required' },
    { name: 'vehicle_status_id', type: 'select', label: 'Estado', validations: 'required', url: '/config/vehicles/statuses', singleSelection: true },
    { name: 'model', type: 'text', label: 'Modelo' },
    { name: 'registration_date', type: 'date', label: 'Fecha Matriculación' },
    { name: 'itv_date', type: 'date', label: 'Fecha ITV' },
    { name: 'next_itv_date', type: 'date', label: 'Próxima ITV' },
    { name: 'maintenance_km', type: 'number', label: 'Km Mantenimiento Actual' },
    { name: 'next_maintenance_km', type: 'number', label: 'Próximo Mantenimiento (km)' },
  ];

  form: GenericForm = {
    successTitle: 'Vehículo creado correctamente',
    errorTitle: 'Error al crear vehículo',
    method: 'POST',
    fields: this.formFields,
    name: 'vehicle',
    createButtonTitle: 'Nuevo Vehículo',
    cols: 2,
    createApiSlug: '/config/vehicles/store',
    formTitle: 'Crear Vehículo',
    formButtonTitle: 'Crear',
    width: '4xl',
  };

  tableActions: GenericTableAction[] = [
    {
      name: 'Editar',
      key: 'edit',
      form: {
        method: 'PUT',
        successTitle: 'Vehículo editado correctamente',
        errorTitle: 'Error al editar vehículo',
        fields: this.formFieldsEdit,
        name: 'vehicle',
        createButtonTitle: '',
        cols: 2,
        createApiSlug: '',
        originalUpdateApiSlug: '/config/vehicles/update/{{id}}',
        updateApiSlug: '',
        originalFormTitle: 'Editar {{license_plate}}',
        formTitle: '',
        formButtonTitle: 'Guardar cambios',
        width: '4xl',
      },
      completeForm: true,
      replaceAllRowOnResponse: true,
      icon: '<svg  xmlns="http://www.w3.org/2000/svg" class="w-4 text-dark"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1.8"  stroke-linecap="round"  stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4" /><path d="M13.5 6.5l4 4" /><path d="M16 19h6" /></svg>',
      confirmation: false
    },
    {
      name: 'Eliminar',
      key: 'delete',
      method: 'DELETE',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7l16 0"/><path d="M10 11l0 6"/><path d="M14 11l0 6"/><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-12"/><path d="M9 7v-3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3"/></svg>',
      confirmation: true,
      questionText: '¿Desea eliminar el vehículo?',
      deleteRowOnResponse: true,
      actionSlug: '/config/vehicles/delete/{{id}}',
    }
  ];

  table: GenericTable<Paginator<any>> = {
    columns: this.tableColums,
    items: [],
    type: 'generic',
    loadItemsSlug: '/config/vehicles/index',
    paginate: true,
    name: 'vehiculos',
    actions: this.tableActions
  };

  filters: Filter[] = [
    { type: 'search', key: 'license_plate|model', operator: 'like', placeholder: 'Matrícula o modelo' },
    { type: 'multiselect', key: 'status.name', operator: 'in', placeholder: 'Estado', url: '/config/vehicles/statuses', relation_filter_column: 'vehicle_status_id' },
  ];

  genericCRUD: GenericCRUD<Paginator<any>> = {
    genericForm: this.form,
    genericTable: this.table,
    genericFilters: this.filters,
    useModalForm: true
  }
}
